module.exports = __webpack_public_path__ + "img/c06_unitchariotarcher_Normal_ua.d98b4ff5.webp";